<div id="container" (onclick)="clear()">
    <img src="../../../assets/sml_calendar.png" alt="dp"  width="15px" height="15px" id="img">
    <div class="text"  id="{{task.searchableID}}" contenteditable="false" class="truncate " class="{{style}}">  {{task.dueDate}}</div>
</div>

